<template>
  <div class="web-header" role="banner" aria-label="global-navigtaion-bar">
    <appBanner v-show="$route.path === '/orders/complete'" />
    <MainBanner v-show="$route.path !== '/orders/complete'" />
    <Desktop
      :list="navigationList"
      :isAuth="isAuthenticated"
      :userType="userType"
      :signout="signout"
      v-if="!mixinsIsMobile"
    />
    <Mobile
      :list="navigationList"
      :isAuth="isAuthenticated"
      :userType="userType"
      :signout="signout"
      v-else
    />
  </div>
</template>

<script>
import channelTalk from "@/helpers/channelTalk";
import Desktop from "./Desktop.vue";
import mixinMediaQuery from "@/mixins/mixinMediaQuery";
import Mobile from "./Mobile/layout.vue";
import appBanner from "@/components/common/AppBanner/index";
import MainBanner from "@/components/common/MainBanner/index";

export default {
  mixins: [mixinMediaQuery],
  components: {
    Desktop,
    Mobile,
    appBanner,
    MainBanner,
  },
  data() {
    return {
      navigationList: [
        {
          title: "주문접수",
          path: "/orders/form",
          auth: false,
          children: [
            {
              name: "주문접수",
              path: "/orders/form",
              userType: "all",
            },
            {
              name: "장바구니",
              path: "/orders/purchase",
              userType: "all",
            },
          ],
        },
        {
          title: "주문내역",
          path: "/orders/list/my",
          auth: true,
          children: [
            {
              name: "주문내역",
              path: "/orders/list/my",
              userType: "all",
            },
            {
              name: "구성원 주문내역",
              path: "/orders/list/member?p=1",
              userType: "manager",
            },
          ],
        },
        {
          title: "고객지원",
          path: "/services/notices",
          auth: false,
          children: [
            {
              name: "공지사항",
              path: "/services/notices",
              userType: "all",
            },
            {
              name: "자주묻는 질문",
              path: "/services/faq",
              userType: "all",
            },
            {
              name: "이용약관",
              path: "/services/tos",
              userType: "all",
            },
          ],
        },
        {
          title: "고객혜택",
          path: "/benefits",
          userType: "all",
        },
      ],
    };
  },
  methods: {
    signout() {
      this.$store.dispatch("auth/signout");
      channelTalk.shutdown();
      this.$router.push("/").catch(() => {});
    },
  },
  watch: {
    mixinsIsMobile(val) {
      if (!val) {
        document.body.classList.remove("modal-open");
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"]();
    },
    userType() {
      return this.$store.getters["auth/tokenPayload"]().type;
    },
  },
  mounted() {
    const header = document.querySelector(".web-header");
    const mainBanner = document.querySelector(".main-banner");
    const appBanner = document.querySelector(".app-banner");

    //header 스타일 변경
    if (header) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 80) {
          header.classList.add("after-style");
        } else {
          header.classList.remove("after-style");
        }
      });
    }

    //main-banner 스타일변경
    if (mainBanner) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 80) {
          mainBanner.classList.add("remove-banner");
        } else {
          mainBanner.classList.remove("remove-banner");
        }
      });
    }

    //app-banner 스타일변경
    if (appBanner) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 100) {
          appBanner.classList.add("remove-banner");
        } else {
          appBanner.classList.remove("remove-banner");
        }
      });
    }
  },
};
</script>

<style scoped>
.web-header {
  box-sizing: border-box;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 9999;
  background-color: transparent;
}

.after-style {
  box-sizing: border-box;
  background-color: var(--white);
  border-bottom: 1px solid var(--gray-200);
  transition: background-color 0.3s ease;
  top: 0px;
  position: fixed;
}
.render {
  display: none;
}

.remove-banner {
  display: none;
}

.mobile-banner {
  display: none !important;
}

.open-gnb {
  top: 0px !important;
  position: fixed !important;
}

@media all and (min-width: 1024px) {
  .render {
    display: block;
  }

  .render-mobile {
    display: none;
  }

  .web-header {
    /* padding: 0px 32px; */
    transition: background-color 0.3s ease;
  }

  .web-header:hover {
    background-color: var(--white);
  }

  .after-style {
    background-color: rgba(255, 255, 255, 0.9);
  }
}
</style>
